'use client';
import React from 'react';

import { TypeBlockImage } from '@fm-nx/contentful-types';
import ImageResponsiveFull from '../image-responsive-full/image-responsive-full';
import { useContentfulLiveUpdates, useContentfulInspectorMode } from '@contentful/live-preview/react';

// https://dev.to/yago/understanding-next-image-13ff
// automatic responsive

export const BlockImage = (props: TypeBlockImage<'WITHOUT_UNRESOLVABLE_LINKS'>) => {
    const { fields } = props;
    const { isFullBleed, images } = fields;
    const updatedBlock = useContentfulLiveUpdates(props);
    const inspectorProps = useContentfulInspectorMode({ entryId: updatedBlock.sys.id });

    if (!fields) return null;

    if (images.length > 1) {
        // TODO: add slideshow
        return <div>Slideshow</div>;
    }

    if (!isFullBleed && updatedBlock?.fields.images[0]) {
        return (
            <div className="relative my-16 w-full mx-auto max-w-container">
                <div className="block mx-6 md:mx-0 md:grid md:grid-cols-14">
                    <div className="col-span-12 col-start-2 bg-green-400">
                        <ImageResponsiveFull image={updatedBlock?.fields.images[0]} />
                    </div>
                </div>
            </div>
        );
    }
    if (fields.images[0]) {
        return (
            <div className="relative my-16">
                <ImageResponsiveFull image={fields.images[0]} />
            </div>
        );
    }
    return null;
};

export default BlockImage;
